import classnames from "classnames";
import * as React from 'react';
import { Logo } from '../Logo/Logo';
import { Navigation } from '../Navigation/Navigation';

export const MobileMenuDrawer: React.FC<Props> = (props) => {
    return (
    <div
        className = {classnames("mobile-menu-drawer", {"is-hidden": !props.isShown})}
        onClick = {props.onClickOutside}
    >
        <div className = "mobile-menu-drawer__window">
            <ul>
                <li>
                    <div className = "mobile-menu-drawer__logo">
                        <Logo />
                    </div>
                    <div className = "mobile-menu-drawer__close" onClick = {props.onClickOutside}>
                    <i className="fa-light fa-angle-double-left"></i>
                    </div>
                </li>
            </ul>
            <Navigation ismobile={true}
            />
        </div>
    </div>
    )
}

interface Props {
    isShown: boolean;
    onClickOutside: () => void; 
}